import React, { useState } from 'react';
import AccountingFilter, { ClosedFilter } from './components/AccountingFilter';
import ClosedReport from './components/ClosedReport';
import Frame from './components/Frame';
import Home from './components/Home';
import UnifiedReport from './components/UnifiedReport';

function AccountingApp() {
  const [toggleKey, setToggleKey] = useState(0);
  return (
    <Frame.Base>
      {toggleKey === 0 && <Home setToggle={setToggleKey} />}
      {toggleKey === 1 && (
        <>
          <AccountingFilter />
          <UnifiedReport />
        </>
      )}
      {toggleKey === 2 && (
        <>
          <ClosedFilter />
          <ClosedReport />
        </>
      )}
    </Frame.Base>
  );
}

export default AccountingApp;
